import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import borderBottom from '../../assets/images/borderBottom.png';
import PendingTimer from '../timer/PendingTimer';

function PaymentStatusCard({
  status, handleRedirect, handleUpdateStatus, orgId, transactionId, organizationData,
}) {
  const isPollingAlreadyDone = useRef(false);
  const updatePollingRef = (value) => {
    isPollingAlreadyDone.current = value;
  };
  const statusConfig = {
    // failure: {
    //     color: 'text-red-500',
    //     icon: (
    //         <div className="w-28 h-28 rounded-full flex items-center justify-center">
    //             <FailureSVG/>
    //         </div>
    //     ),
    //     title: '',
    //     description: 'We regret to inform you that your payment was unsuccessful. If any amount was deducted, it will be refunded and should appear in your account within [7-10] days.',
    //     buttonText: 'Back To Application',
    // },
    // success: {
    //     color: 'text-green-500',
    //     icon: (
    //         <div className="w-28 h-28 rounded-full flex items-center justify-center">
    //             <SuccessSVG/>
    //         </div>
    //     ),
    //     title: 'Congrats!',
    //     description: 'We are pleased to confirm that your order was successfully processed',
    //     buttonText: 'Back To Application',
    // },
    pending: {
      color: 'text-blue-500',
      icon: (
        <div className="h-28 w-28 rounded-full flex items-center justify-center ">
          <iframe
            title="hold on"
            src="https://lottie.host/embed/d1fca66e-625d-4d89-8a1b-9141d82f15d9/J2fOWyNX2V.lottie"
          />
        </div>
      ),
      title: 'Hold On!',
      description: 'We are verifying your payment status',
      buttonText: 'Back To Application',
    },
  };

  const config = statusConfig[status];
  if (status === 'success') {
    window.location = `${organizationData.thankYou.successURL}?redirect=${organizationData.redirect.successURL}`;
  } else if (status === 'failure') {
    window.location = `${organizationData.thankYou.failureURL}?redirect=${organizationData.redirect.failureURL}`;
  } else if (config) {
    return (
      <div className="fixed inset-0 z-50 bg-blue-900 overflow-hidden">
        {/* <img */}
        {/*  src={isSmallScreen ? backPNG : backFullPNG} */}
        {/*  className="absolute inset-0 w-screen h-screen object-cover" */}
        {/*  alt="background" */}
        {/* /> */}

        <div className="relative z-10 flex items-center justify-center h-full p-4">
          <div className="bg-white rounded-lg max-w-md w-full text-center p-6 relative shadow-xl">
            <div className="flex justify-center mb-6">
              {config.icon}
            </div>
            <h2 className="text-2xl font-semibold text-dark mb-4">
              {config.title}
            </h2>
            <p className="text-gray-600 text-lg mb-6">
              {config.description}
            </p>

            {(status === 'pending' && !isPollingAlreadyDone?.current) && (
            <PendingTimer
              updatePollingFn={updatePollingRef}
              transactionId={transactionId}
              handleUpdateStatus={handleUpdateStatus}
              orgId={orgId}
            />
            )}

            {config.buttonText && (
            <button
              type="button"
              onClick={handleRedirect}
              className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors"
            >
              {config.buttonText}
            </button>
            )}
          </div>
          <img alt="" src={borderBottom} />
        </div>
      </div>
    );
  }
}

PaymentStatusCard.propTypes = {
  status: PropTypes.oneOf(['success', 'failure', 'pending']).isRequired,
  handleRedirect: PropTypes.func.isRequired,
  handleUpdateStatus: PropTypes.func.isRequired,
  orgId: PropTypes.string,
  transactionId: PropTypes.string.isRequired,
  organizationData: PropTypes.shape({
    thankYou: PropTypes.shape({ successURL: PropTypes.string, failureURL: PropTypes.string }),
    redirect: PropTypes.shape({ successURL: PropTypes.string, failureURL: PropTypes.string }),
  }),
};

export default PaymentStatusCard;
